import { render } from "./knobs.svg?vue&type=template&id=608090a6"
const script = {}
script.render = render

export default script